/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import React from "react";
import styled from "styled-components";

import {countryCodeChoices} from "./constants";

const CountryDropdown = ({
  selectedItem,
  setShowDropdown,
  callback,
  dropdownRef,
  showDropdown
}) => {
  return (
    <>
      {
        showDropdown ? (
          <SettingDropdown ref={dropdownRef} className={showDropdown && "toggled"}>
            {countryCodeChoices.map((item) => (
              <OptionWrapper
                key={item.code}
                onClick={() => {
                  setShowDropdown(false);
                  callback(item);
                }}
                className={item.code === selectedItem && "active"}
              >
                <img src={item.iconUrl} alt={item.country} />
                <p>{item.country}</p>
              </OptionWrapper>
            ))}
          </SettingDropdown>
        ) : null
      }
    </>
  );
};

const SettingDropdown = styled.div`
  position: absolute;
  z-index: 1;
  top: 52px;
  left: 1px;
  background-color: #fff;
  box-shadow: 0px 1px 7px 3px rgba(0,0,0,0.1);
  padding: 1rem;
  width: 100%;
  border-radius: 8px;
  z-index: 10;
  pointer-events: none;
  transform: translateY(25px);
  opacity: 0;
  transition: all 0.25s ease-in-out;
  max-height: 200px;
  overflow: scroll;
  &.toggled {
    pointer-events: all;
    transform: unset;
    opacity: 1;
  }
  &::before {
    content: '';
    position: absolute;
    box-shadow: -1px -1px 1px 0px rgba(0,0,0,0.05);
    top: -10px;
    right: 14px;
    width: 20px;
    height: 20px;
    background: #fff;
    transform: rotate(45deg);
    z-index: -1;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  padding: 1rem 0;
  width: 100%;
  gap: 2rem;
  justify-content: flex-start;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(103, 37, 244, 0.10);
  }
  p {
    font-weight: 500;
    font-size: 1.5rem;
    text-transform: capitalize;
    letter-spacing: 1.1;
    text-align: right;
  }
  img {
    width: 10%;
  }
  &:hover, &.active {
    color: #6725F4;
    opacity: 1;
  }
`;

export default CountryDropdown;
